import * as classNames from 'classnames'
import * as React from 'react'

export interface IHorizontalSelectorItem {
  isSelected?: boolean
  children: any
}

const HorizontalSelectorItem = ({ isSelected = false, children }: IHorizontalSelectorItem) => {
  const itemClasses = classNames({
    'z2 font-grey2 nowrap mr2': true,
    'bb-green font-dark-grey': isSelected
  })
  return <div className={itemClasses}>{children}</div>
}

export default HorizontalSelectorItem



// WEBPACK FOOTER //
// ./src/components/HorizontalSelectorItem.tsx